import { deconstructResourceId, ResourceId } from "./ResourceId";

const resourceLinkMap: Record<string, (id: string) => string> = {
  crm: (id) => `/crm/customers/id/${id}`,
  order: (id) => `/orders/${id}`,
  invoice: (id) => `/faktury/watki/${id}`,
  product: (id) => `/items/${id}`,
  shopifyOrder: (id) => `/specjalista/order-fulfillment/id/${id}`
};

export const getResourceLink = (resourceId: ResourceId): string => {
  const { identifier, namespace } = deconstructResourceId(resourceId);
  return resourceLinkMap[namespace]?.(identifier) ?? `/unknown/${identifier}`;
};
